import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { userAPI } from "components/common/api";
import { setCookie, getCookie, delCookie } from "components/common/cookie";

// 초기값
const initialState = {
  user: null,
  isLogin: false,
  loading: false,
  kakaoInfo: {},
  userInfo: {},
  isEditDone: false,
  isCertificated: false,
  auth: "NONE",
};

const kakaoLogin = createAsyncThunk(
  "user/kakaoLogin",
  async (code, thunkAPI) => {
    try {
      const res = await userAPI.kakaoLogin(code);
      console.log(res.data);
      setCookie("KakaoAccessToken", res.data.access_token, { path: "/" });
      setCookie("KakaoRefreshToken", res.data.refresh_token, { path: "/" });

      const _res = await userAPI.GetUserInfosKakao({
        token: res.data.access_token,
      });
      console.log(_res);
      if (_res.data.message === "로그인 성공") {
        setCookie("AccessToken", _res.data.accessToken, { path: "/" });
        setCookie("RefreshToken", _res.data.refreshToken, { path: "/" });
        setCookie("userId", _res.data.userId, { path: "/" });
      }
      return thunkAPI.fulfillWithValue(_res.data);
    } catch (err) {
      // console.log(err)
      return thunkAPI.rejectWithValue(err);
    }
  }
);

const getUserInfos = createAsyncThunk("user/getUserInfos", async () => {
  const config = {
    Authorization: `Bearer ${getCookie("AccessToken")}`,
  };
  try {
    const res = await userAPI.GetUserInfos(config);
    localStorage.setItem("nickname", res.data.nickname);
    localStorage.setItem("profileImage", res.data.profileImage);
    localStorage.setItem("annual", res.data.annual);
    localStorage.setItem("city", res.data.city);
    localStorage.setItem("region", res.data.region);
    localStorage.setItem("isRegisteration", res.data.isRegistration);
    localStorage.setItem("level", res.data.level);
    localStorage.setItem("socialId", res.data.socialId);
    console.log(res);
    return res.data;
  } catch (err) {
    // console.log(err)
    return err.response.data;
  }
});

const postCertiFile = createAsyncThunk(
  "user/postCertiFile",
  async (formData, thunkAPI) => {
    try {
      const res = await userAPI.PostCertiFile(formData);
      console.log(res.data);
      alert("사업자 인증이 완료되었습니다.");
      return thunkAPI.fulfillWithValue(res.data);
    } catch (err) {
      console.log(err);
      const errMsg = err.response.data.message;
      window.alert(errMsg);
      return thunkAPI.rejectWithValue(err);
    }
  }
);

const updateCertiFile = createAsyncThunk(
  "user/updateCertiFile",
  async (formData, thunkAPI) => {
    try {
      const token = getCookie("AccessToken");
      const res = await userAPI.UpdateCertiFile(formData, token);
      alert("사업자 인증이 완료되었습니다.");
      return thunkAPI.fulfillWithValue(res.data);
    } catch (err) {
      const errMsg = err.response.data.message;
      window.alert(errMsg);
      return thunkAPI.rejectWithValue(err);
    }
  }
);

const unCertiSignup = createAsyncThunk(
  "user/unCertiSignup",
  async (type, thunkAPI) => {
    try {
      const res = await userAPI.UncertiSignup(
        type,
        getCookie("KakaoAccessToken")
      );
      console.log(res.data);
      return thunkAPI.fulfillWithValue(res.data);
    } catch (err) {
      console.log(err);
      const errMsg = err.response.data.message;
      window.alert(errMsg);
      return thunkAPI.rejectWithValue(err);
    }
  }
);

const kakaoLogout = createAsyncThunk("user/kakaoLogout", async (thunkAPI) => {
  const data = {
    kakaoAccessToken: getCookie("KakaoAccessToken"),
    userId: getCookie("userId"),
  };
  console.log(data);
  const response = await userAPI.kakaoLogout(data);
  console.log(response);
  return response.data;
});

const kakaoUnlink = createAsyncThunk("user/kakaoUnlink", async (thunkAPI) => {
  try {
    const data = {
      kakaoAccessToken: getCookie("KakaoAccessToken"),
      userId: getCookie("userId"),
    };
    const res = await userAPI.kakaoUnlink(data);
    console.log(res);
    localStorage.clear();
    delCookie("AccessToken");
    alert("로그아웃 완료");
    return thunkAPI.fulfillWithValue(res.data);
  } catch (err) {
    console.log(err);
    localStorage.clear();
    return thunkAPI.rejectWithValue(err);
  }

  // const data = {
  //   kakaoAccessToken: getCookie("KakaoAccessToken"),
  //   userId: getCookie("userId")
  // }
  // const response = await userAPI.kakaoUnlink(data)
  // console.log(response)
  // return response.status;
});

const putProfile = createAsyncThunk("user/putProfile", async (formdata) => {
  try {
    const config = {
      Authorization: `Bearer ${getCookie("AccessToken")}`,
    };
    const res = await userAPI.UpdateProfile(formdata, config);
    console.log(res);
    alert("수정 완료");
    return res.data;
  } catch (err) {
    alert(err.response.data.message);
    return err.response.data;
  }
});

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    isCertificated: (state) => {
      state.auth = "CERTIFICATED";
    },
    isNormal: (state) => {
      state.auth = "NORMAL";
    },
    isAdmin: (state) => {
      state.auth = "ADMIN";
    },
    isNone: (state) => {
      state.auth = "NONE";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserInfos.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUserInfos.fulfilled, (state, action) => {
        state.userInfo = action.payload;
        state.isLogin = true;
      })
      .addCase(getUserInfos.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(postCertiFile.pending, (state) => {
        state.loading = true;
      })
      .addCase(postCertiFile.fulfilled, (state, action) => {
        state.isCertificated = true;
      })
      .addCase(postCertiFile.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(updateCertiFile.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCertiFile.fulfilled, (state, action) => {
        state.isCertificated = true;
      })
      .addCase(updateCertiFile.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(putProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(putProfile.fulfilled, (state, action) => {
        state.isEditDone = true;
      })
      .addCase(putProfile.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(kakaoLogin.pending, (state) => {
        state.loading = true;
      })
      .addCase(kakaoLogin.fulfilled, (state, action) => {
        state.kakaoInfo = action.payload;
      })
      .addCase(kakaoLogin.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(kakaoUnlink.pending, (state) => {
        state.loading = true;
      })
      .addCase(kakaoUnlink.fulfilled, (state, action) => {
        state.isLogin = false;
        state.userInfo = {};
      })
      .addCase(kakaoUnlink.rejected, (state) => {
        state.loading = false;
      });
  },
});

const UserCreators = {
  getUserInfos,
  kakaoLogout,
  kakaoLogin,
  kakaoUnlink,
  postCertiFile,
  updateCertiFile,
  unCertiSignup,
  putProfile,
};

export { UserCreators };

export const { isCertificated, isNormal, isAdmin, isNone } = userSlice.actions;

export default userSlice.reducer;
